"use client"

import { CYCLE_FROM_QUERY_KEY, ITEM_FROM_QUERY_KEY } from "common/helper/const"
import { ItemList, ReportCycle } from "common/interface/interface"
import { usePathname, useRouter, useSearchParams } from "next/navigation"
import React from "react"
import { SelectProps } from "antd"

import Style from "./index.module.scss"
import SelectMix from "./mix"

type LabelRender = SelectProps["labelRender"]

type Props = {
	itemId: number
	cycleId: number
	categoryOptions: ItemList[]
	frequencyOptions: ReportCycle[]
}

const SelectFilter: React.FC<Props> = ({ itemId, cycleId, categoryOptions, frequencyOptions }) => {
	const router = useRouter()
	const pathname = usePathname()
	const searchParams = useSearchParams()

	const updateParam = (key: string, value?: string | number) => {
		const params = new URLSearchParams(searchParams.toString())
		// @ts-ignore
		// const errorValue = undefined.property

		if (key === ITEM_FROM_QUERY_KEY) {
			const itemValue = categoryOptions.find((item) => item.id === Number(value ?? 0))?.en_name
			params.set(key, itemValue ?? "")
		}
		if (key === CYCLE_FROM_QUERY_KEY) {
			const cycleValue = frequencyOptions.find((item) => item.cycle === Number(value ?? 0))?.name
			params.set(key, cycleValue ?? "")
		}

		router.push(`${pathname}?${params.toString()}`, { scroll: false })
		router.refresh()
	}

	const labelRender: LabelRender = (props) => {
		const { label, value } = props

		if (!value) {
			return "Category"
		}
		return label
	}

	return (
		<div className={Style.filterBar}>
			<div className={Style.group}>
				<SelectMix
					value={cycleId}
					options={frequencyOptions.map((item) => ({ label: item.name, value: item.cycle }))}
					onChange={(val) => updateParam(CYCLE_FROM_QUERY_KEY, val)}
					placeholder="All"
					className={Style.freqSelect}
				/>
			</div>
			<div className={Style.group}>
				<SelectMix
					value={itemId}
					options={categoryOptions.map((item) => ({
						label: item.en_name,
						value: item.id,
					}))}
					onChange={(val) => updateParam(ITEM_FROM_QUERY_KEY, val)}
					placeholder="Category"
					className={Style.categorySelect}
					labelRender={labelRender}
				/>
			</div>
		</div>
	)
}

export default SelectFilter
